var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e4da",
    d: "m162.713 37.744 1.645 42.448-45.018-45.079zM38.034 38.156l-1.609 41.572 44.084-44.15zM38.034 161.816l-1.609-41.575 44.084 44.152zM162.526 161.982l1.636-43.151-44.619 45.828zM131.881 101.057c0 6.02-4.881 10.899-10.901 10.899-6.018 0-10.901-4.88-10.901-10.899 0-6.021 4.884-10.898 10.901-10.898 6.02 0 10.901 4.877 10.901 10.898M91.981 101.057c0 5.977-4.842 10.816-10.816 10.816s-10.819-4.84-10.819-10.816c0-5.973 4.845-10.818 10.819-10.818s10.816 4.845 10.816 10.818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e4da",
    d: "m100.376 23.611-76.62 76.62 76.62 76.621 76.622-76.621zm0 120.999c-24.508 0-44.382-19.867-44.382-44.378 0-24.509 19.874-44.379 44.382-44.379s44.378 19.87 44.378 44.379c0 24.511-19.871 44.378-44.378 44.378"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreme);
export default __webpack_public_path__ + "static/media/icon-creme.42b45fe5f7c95ef7a43239430d941f90.svg";
export { ForwardRef as ReactComponent };